import axios from 'axios';

const instance = axios.create({
  baseURL: import.meta.env.VITE_AUTH_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// Type littéral restreint aux valeurs autorisées
type FlowType = 'registration' | 'login' | 'logout' | 'settings' | 'recovery' | 'verification' | 'errors';
type BrowserFlowType = Exclude<FlowType, 'logout' | 'errors'>;

interface FlowResponse {
  data: any;
}

export async function initFlow(
  flow: FlowType,
  extraHeaders: Record<string, string> = {}
): Promise<FlowResponse> {
  try {
    const response = await instance.get(`/self-service/${flow}/browser`, {
      headers: {
        ...extraHeaders,
      },
    });
    return response;
  } catch (error) {
    console.error('Error during flow initialization:', error);
    throw error;
  }
}

export async function getFlowInfo(flow: BrowserFlowType, flowId: string): Promise<FlowResponse> {
  try {
    const response = await instance.get(`/self-service/${flow}/flows`, {
      params: { id: flowId },
    });
    return response;
  } catch (error) {
    console.error('Error during flow information retrieval:', error);
    throw error;
  }
}
